import { html } from 'lit';
const CenterPeek =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 4.75a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0V5c0-.966.784-1.75 1.75-1.75h2a.75.75 0 0 1 0 1.5zM16.25 4a.75.75 0 0 1 .75-.75h2c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0V5a.25.25 0 0 0-.25-.25h-2a.75.75 0 0 1-.75-.75m-9 5.1c0-.47.38-.85.85-.85h7.8c.47 0 .85.38.85.85v5.8c0 .47-.38.85-.85.85H8.1a.85.85 0 0 1-.85-.85zm1.5.65v4.5h6.5v-4.5zM4 16.25a.75.75 0 0 1 .75.75v2c0 .138.112.25.25.25h2a.75.75 0 0 1 0 1.5H5A1.75 1.75 0 0 1 3.25 19v-2a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75v2A1.75 1.75 0 0 1 19 20.75h-2a.75.75 0 0 1 0-1.5h2a.25.25 0 0 0 .25-.25v-2a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
export default CenterPeek;
